import { GuidSanitizer } from "./GuidSanitizer";
import { LookupSanitizer } from "./LookupSanitizer";

export class Sanitizer {
    public static Lookup = new LookupSanitizer();
    public static Guid = new GuidSanitizer();
}